import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { CrisisMonitoringPage } from "@/components/site/CrisisMonitoringPage";

import { pageSchemas } from "@/lib/seo/page-schema";
const DESCRIPTION =
  "Perceptica's crisis monitoring and crisis analysis spot escalation early and brief your PR team in real time across Southeast Europe. Be ready before it breaks.";

export const Route = createFileRoute("/media-analysis/crisis-monitoring")({
  head: () => ({
    meta: [
      { title: "Crisis Monitoring & Crisis Analysis | Perceptica" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "Crisis Monitoring & Crisis Analysis | Perceptica" },
      { property: "og:description", content: DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Crisis Monitoring & Crisis Analysis | Perceptica" },
      { name: "twitter:description", content: DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/media-analysis/crisis-monitoring" },
      ...ogImageMeta("en", "/media-analysis/crisis-monitoring"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/media-analysis/crisis-monitoring", service: { name: "Crisis monitoring", description: "Perceptica crisis monitoring for Southeast Europe.", serviceType: "Crisis monitoring" } }),
  }),
  component: CrisisMonitoringPage,
});
